import { NgModule, ValueProvider } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UploadedFilesDirective, FilesDirective } from './files.directive';
import { UploaderComponent } from './uploader.component';
import { UploaderModule } from './uploader.module';
/**
 * NgModule definition for the Uploader component with providers.
 */
export class UploaderAllModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, UploaderModule],
    exports: [
        UploaderModule
    ],
    providers:[
        
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function UploaderAllModule_tsickle_Closure_declarations() {
/** @type {?} */
UploaderAllModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
UploaderAllModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
